/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GeoJsonFeatureDtoFromJSON, GeoJsonFeatureDtoToJSON, } from './GeoJsonFeatureDto';
/**
 * Check if a given object implements the GeoJsonFeatureCollectionDto interface.
 */
export function instanceOfGeoJsonFeatureCollectionDto(value) {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "features" in value;
    return isInstance;
}
export function GeoJsonFeatureCollectionDtoFromJSON(json) {
    return GeoJsonFeatureCollectionDtoFromJSONTyped(json, false);
}
export function GeoJsonFeatureCollectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': json['type'],
        'features': (json['features'] === null ? null : json['features'].map(GeoJsonFeatureDtoFromJSON)),
        'hasMore': !exists(json, 'hasMore') ? undefined : json['hasMore'],
    };
}
export function GeoJsonFeatureCollectionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'features': (value.features === null ? null : value.features.map(GeoJsonFeatureDtoToJSON)),
        'hasMore': value.hasMore,
    };
}
